<template>
  <div class="my-fans">
    <el-table
      height="calc(100vh - 310px)"
      :data="data"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column label="作者" width="width">
        <template slot-scope="scope">
          <div class="info-line">
            <img
              class="avatar"
              :src="
                scope.row.avatar || require('../../images/teacherCover.png')
              "
              alt=""
            />
            <div>
              <div class="info-text">{{ scope.row.nick_name }}</div>
              <div class="info-text">{{ scope.row.school.name }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="resource_count"
        label="发布资源数量"
      ></el-table-column>
      <!-- <el-table-column
        prop="resource_gftj_count"
        label="官方推荐资源数量"
      ></el-table-column> -->
      <el-table-column prop="fans_count" label="粉丝数"></el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <div class="small-button" @click="toIndex(scope.row.id)">
              查看主页
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      background
      @current-change="onPageChange"
      :current-page="page"
      :page-size="10"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getFans } from '@/api/api'
export default {
  name: 'MyFans',
  data: () => ({
    data: [],
    page: 1,
    total: 0,
  }),
  mounted() {
    this.search()
  },
  methods: {
    search() {
      getFans(this.page).then((res) => {
        console.log('fans', res)
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    toIndex(id) {
      // sessionStorage.removeItem('yey-mineMenuIndex')
      this.$router.push(`authorIndex?id=${id}`)
    },
    cancelFollow() {},
    onPageChange(e) {
      this.page = e
      this.search()
    },
  },
}
</script>

<style lang="less" scoped>
.my-fans {
  padding: 20px;
}
.info-line {
  display: flex;
}
.avatar {
  width: 50px;
  height: 50px;
  margin-right: 8px;
  border-radius: 50%;
}
.info-text {
  font-size: 14px;
  color: #4c4c4c;
}
.small-button {
  width: 74px;
  height: 24px;
  margin-right: 12px;
  border-radius: 12px;
  border: 1px solid #00aeff;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  color: #00aeff;
  user-select: none;
  cursor: pointer;
}
.small-button-cancel {
  width: 74px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid #808080;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  color: #808080;
  user-select: none;
  cursor: pointer;
}
</style>
